import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AnimatedProgressBarComponent } from "./progress-bar.component";
import { NgxPaginationModule } from "ngx-pagination";

import { ReactiveFormsModule } from "@angular/forms";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { CarouselComponent } from "./carousel/carousel.component";
import { FooterComponent } from "./footer/footer.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AppRoutingModule } from "./app-routing.module";
import { LoginComponent } from "./login/login.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { MatchdetailComponent } from "./matchdetail/matchdetail.component";
import { MatTabsModule } from "@angular/material/tabs";
import { BetslipComponent } from "./betslip/betslip.component";
import { BetslipPlainComponent } from "./betslip2/betslip.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { FormsModule } from "@angular/forms";
import { NewDashboardComponent } from "./new-dashboard/new-dashboard.component";
import { RegisterComponent } from "./register/register.component";
import { RechargeWalletComponent } from "./recharge-wallet/recharge-wallet.component";
import { RechargeHistoryComponent } from "./recharge-history/recharge-history.component";
import { AuthInterceptor } from "./auth.interceptor";
import { MatchComponent } from "./match/match.component";
import { CricketComponent } from "./cricket/cricket.component";
import { FootballComponent } from "./football/football.component";
import { TennisComponent } from "./tennis/tennis.component";
import { ToastrModule } from "ngx-toastr";
import { InplayMatchesComponent } from "./inplay-matches/inplay-matches.component";
import { ChangePasswordComponent } from "./modals/change-password/change-password.component";
import { TermsConditionsComponent } from "./terms-conditions/terms-conditions.component";
import { ProfileComponent } from "./profile/profile.component";
import { TennisdetailsComponent } from "./tennisdetails/tennisdetails.component";
import { LedgerComponent } from "./ledger/ledger.component";
import { MatExpansionModule } from "@angular/material/expansion";
import { IvyCarouselModule } from "angular-responsive-carousel";
import { MybetsComponent } from "./mybets/mybets.component";
import { CasinoComponent } from "./casino/casino.component";
import { TimerOverlayComponent } from "./timer-overlay/timer-overlay.component";
import { SoccerdetailsComponent } from "./soccerdetails/soccerdetails.component";
import { DwRequestsComponent } from "./dw-requests/dw-requests.component";
import { DepositsComponent } from "./deposit/deposit.component";
import { WithdrawsComponent } from "./withdraw/withdraw.component";
import { DepositFormComponent } from "./modals/deposit-form/deposit-form.component";
import { WithdrawFormComponent } from "./modals/withdraw-form/withdraw-form.component";
import { MainComponent } from "./main/main.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { LoginModalComponent } from "./modals/login-model/login-modal.component";
import { RegisterModalComponent } from "./modals/register-modal/register-modal.component";
import { RefererComponent } from "./referer/referer.component";
import { PopupModalComponent } from "./modals/popup/popup.component";
import { LivecasinoComponent } from "./livecasino/casino.component";
import { CasinoDwComponent } from "./casino-dw/casinodw.component";
import { CasinoDepositComponent } from "./modals/casino-deposit/deposit-form.component";
import { CasinoWithdrawComponent } from "./modals/casino-withdraw/withdraw-form.component";
import { CasinoLedgerComponent } from "./casino-ladger/ledger.component";
import { ProofListComponent } from "./modals/proof-list/proof-list.component";
import { BetDetailComponent } from "./modals/bet-details/detail.component";
import { CasinoDetailComponent } from "./casino-detail/detail.component";
import { MybetListComponent } from "./my-bets/bets.component";
import { SupportComponent } from "./modals/support/support.component";
import { RulesModelComponent } from "./modals/rule-book/book.component";
import { BetListModelComponent } from "./modals/bet-list/list.component";
import { UnsettlebetListComponent } from "./unsettled-bets/bets.component";
import { ProfitLossComponent } from "./profit-loss/report.component";
import { LandingPageComponent } from "./landing-page/landing-page.component";
import { ComingSoonComponent } from "./coming-soon/detail.component";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { ButtonValueModalComponent } from "./modals/button-value/modal.component";
import { SessionLadder } from "./modals/session-ladder/session-ladder.component";
import { CasinoDTennPattiPopupComponent } from "./modals/casino-result-details/teen-patti20/details.component";
import { CasinoTennPattiOpenPopupComponent } from "./modals/casino-result-details/teen-pattiopen/details.component";
import { CasinoDTennPattiOneDayPopupComponent } from "./modals/casino-result-details/teen-pattioneday/details.component";
import { CasinoDTennPattiTestPopupComponent } from "./modals/casino-result-details/teen-pattitest/details.component";
import { CasinoDCardTreeTwoAPopupComponent } from "./modals/casino-result-details/card32a/details.component";
import { CasinoDCardTreeTwoBPopupComponent } from "./modals/casino-result-details/card32b/details.component";
import { CasinoDLuckyPopupComponent } from "./modals/casino-result-details/lucky7/details.component";
import { CasinoDAndarBaharPopupComponent } from "./modals/casino-result-details/andarbahar/details.component";
import { CasinoDragonTigerPopupComponent } from "./modals/casino-result-details/dragontiger/details.component";
import { CasinoDragonTigerLionPopupComponent } from "./modals/casino-result-details/dragontigerlion/details.component";
import { CasinoAaaPopupComponent } from "./modals/casino-result-details/aaa/details.component";
import { CasinoDPoker20PopupComponent } from "./modals/casino-result-details/poker20/details.component";
import { PlayernamePipe } from "./pipes/playername.pipe";
import { CasinoResultsComponent } from "./casino-results/casino-results.component";
import { Lucky7namePipe } from "./pipes/lucky7name.pipe";
import { TeenPattiTestnamePipe } from "./pipes/teenpatti.pipe";
import { TeenPattiOneDayPipe } from "./pipes/teenpattioneday.pipe";
import { Dt20namePipe } from "./pipes/dt20name.pipe";
import { Card32namePipe } from "./pipes/card32name.pipe";
import { DragonTigerPipe } from "./pipes/dragontiger.pipe";
import { DragonTigerLionPipe } from "./pipes/dragontigerlion.pipe";
import { AaaPipe } from "./pipes/aaa.pipe";
import { Poker20namePipe } from "./pipes/poker20.pipe";
import { PokerOnedayResultComponent } from "./modals/casino-result-details/poker-oneday/poker-oneday.component";
import { Poker6playerResultComponent } from "./modals/casino-result-details/poker6player/poker6player.component";
import { Baccarat1ResultComponent } from "./modals/casino-result-details/baccarat1/baccarat1.component";
import { SecureAuthComponent } from "./secureauth/auth.component";
import { DepositAutopayComponent } from "./modals/deposit-autopay/deposit-autopay.component";

import { LivecasinoIgtechComponent } from "./livecasinoIgtech/casino.component";
import { CasinoDetailIgtechComponent } from "./casino-detailIgtech/detailIGtech.component";

import { BonusComponent } from "./bonus/bonus.component";
import { BonusLedgerComponent } from "./bonus-ledger/bonus-ledger.component";

// static pages
import { ContactPageComponent } from "./static/contactus/detail.component";
import { PrivacyPageComponent } from "./static/privacypolicy/detail.component";
import { GameRulePageComponent } from "./static/gamesrule/detail.component";
import { TermsPageComponent } from "./static/terms/detail.component";
import { CasinoBetSlipComponent } from "./casino-bet-slip/casino-bet-slip.component";
import { CasinoBetSlip2Component } from "./casino-bet-slip2/casino-bet-slip2.component";
import { Poker6Pipe } from "./pipes/poker6.pipe";
import { BaccaratPipe } from "./pipes/baccarat.pipe";
import { Baccarat2ResultComponent } from "./modals/casino-result-details/baccarat2/baccarat2.component";
import { GamenamePipe } from "./pipes/gamename.pipe";
import { WinnernamePipe } from "./pipes/winnername.pipe";
import { Andarbahar2ResultComponent } from "./modals/casino-result-details/andarbahar2-result/andarbahar2-result.component";
import { CapitalizeWordsPipe } from "./pipes/capitalize-words.pipe";
import { NumberFormatterPipe } from "./pipes/number-formatter.pipe";
import { InChangePasswordComponent } from "./modals/in-change-password/in-change-password.component";
import { DaylabelPipe } from "./pipes/daylabel.pipe";
import { LoginauthComponent } from "./loginauth/loginauth.component";

@NgModule({
  declarations: [
    AnimatedProgressBarComponent,
    AppComponent,
    HomeComponent,
    NavbarComponent,
    CarouselComponent,
    FooterComponent,
    DashboardComponent,
    LoginComponent,
    SidenavComponent,
    MatchdetailComponent,
    BetslipComponent,
    BetslipPlainComponent,
    NewDashboardComponent,
    RegisterComponent,
    RechargeWalletComponent,
    RechargeHistoryComponent,
    MatchComponent,
    CricketComponent,
    FootballComponent,
    TennisComponent,
    InplayMatchesComponent,
    ChangePasswordComponent,
    TermsConditionsComponent,
    ProfileComponent,
    TennisdetailsComponent,
    LedgerComponent,
    MybetsComponent,
    CasinoComponent,
    TimerOverlayComponent,
    SoccerdetailsComponent,
    DepositsComponent,
    DwRequestsComponent,
    WithdrawsComponent,
    DepositFormComponent,
    WithdrawFormComponent,
    MainComponent,
    LoginModalComponent,
    RegisterModalComponent,
    RefererComponent,
    PopupModalComponent,
    LivecasinoComponent,
    CasinoDwComponent,
    CasinoDepositComponent,
    CasinoWithdrawComponent,
    CasinoLedgerComponent,
    ProofListComponent,
    BetDetailComponent,
    CasinoDetailComponent,
    MybetListComponent,
    SupportComponent,
    RulesModelComponent,
    UnsettlebetListComponent,
    ProfitLossComponent,
    LandingPageComponent,
    ComingSoonComponent,
    ContactPageComponent,
    PrivacyPageComponent,
    GameRulePageComponent,
    TermsPageComponent,
    BetListModelComponent,
    ButtonValueModalComponent,
    SessionLadder,
    LivecasinoIgtechComponent,
    CasinoDetailIgtechComponent,
    CasinoDTennPattiPopupComponent,
    CasinoTennPattiOpenPopupComponent,
    CasinoDTennPattiOneDayPopupComponent,
    CasinoDTennPattiTestPopupComponent,
    CasinoDCardTreeTwoAPopupComponent,
    CasinoDCardTreeTwoBPopupComponent,
    CasinoDLuckyPopupComponent,
    CasinoDAndarBaharPopupComponent,
    CasinoDragonTigerPopupComponent,
    CasinoDragonTigerLionPopupComponent,
    CasinoAaaPopupComponent,
    CasinoDPoker20PopupComponent,
    PlayernamePipe,
    CasinoResultsComponent,
    Lucky7namePipe,
    TeenPattiTestnamePipe,
    TeenPattiOneDayPipe,
    Dt20namePipe,
    Card32namePipe,
    DragonTigerPipe,
    DragonTigerLionPipe,
    AaaPipe,
    Poker20namePipe,
    CasinoBetSlipComponent,
    CasinoBetSlip2Component,
    PokerOnedayResultComponent,
    Poker6playerResultComponent,
    Poker6Pipe,
    Baccarat1ResultComponent,
    BaccaratPipe,
    Baccarat2ResultComponent,
    GamenamePipe,
    WinnernamePipe,
    Andarbahar2ResultComponent,
    CapitalizeWordsPipe,
    NumberFormatterPipe,
    SecureAuthComponent,
    InChangePasswordComponent,
    DaylabelPipe,
    LoginauthComponent,
    DepositAutopayComponent,
    BonusComponent,
    BonusLedgerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatMenuModule,
    MatTabsModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    FormsModule,
    IvyCarouselModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    NgbCollapseModule,
    MatListModule,
    MatProgressBarModule,
    Ng2SearchPipeModule,
    NgxPaginationModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      preventDuplicates: true,
    }),
    NgbModule,
  ],
  entryComponents: [BetslipComponent, ChangePasswordComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
